import t from 'babel-plugin-yate/macro';
import React, {useCallback, useState} from 'react';

import Button from '../../components/Button';
import {Text} from '../../components/uiElem';

import OfferGroupItem from './OfferGroupItem';
import RadioButton from '../../components/Form/RadioButton';
import OfferGroupItemCetelem from './OfferGroupItemCetelem';

export default function OfferGroup(props) {
  const {items, requestType, handleSelectOffer, groupId, isCetelemRefinance} =
    props;

  const {
    financial_institute,
    financial_institute_logo,
    id: firstItemId,
    is_credit_card: isConsumerFinanceWithCard,
  } = items[0];

  const [selectedOfferId, setSelectedOfferId] = useState(firstItemId);
  const isConsumerFinance = requestType === 4;
  const isPersonalNeeds = requestType === 5;
  const isCreditCard = requestType === 6;

  const heading = useCallback(() => {
    if (isCreditCard || isConsumerFinanceWithCard) {
      return t`Creditul de tip card de credit a fost aprobat in urmatoarele conditii`;
    }

    if (isPersonalNeeds) {
      return t`Creditul de nevoi personale a fost aprobat in urmatoarele conditii`;
    }

    if (isConsumerFinance) {
      return t`Creditul de bunuri de consum a fost aprobat in urmatoarele conditii`;
    }
  }, [
    isCreditCard,
    isPersonalNeeds,
    isConsumerFinance,
    isConsumerFinanceWithCard,
  ]);

  return (
    <div className="flex pl-10 pb-10 relative flex-grow md:flex-grow-0">
      <div className="flex flex-grow flex-col rounded shadow-md bg-white overflow-hidden p-4">
        <div className="px-6 text-center">
          <img
            className="mx-auto"
            src={financial_institute_logo}
            alt={financial_institute}
            width="184"
            height="96"
          />
        </div>

        <div className="py-6 text-center mx-auto max-w-sm">
          <div className="text-18 md:text-22 leading-tight font-medium">
            {heading()}
          </div>
        </div>

        <div className="flex flex-grow mb-8">
          {items.map((item, index) => {
            const {id, insurance} = item;
            const checked = id === selectedOfferId;
            const label =
              insurance === 1
                ? t`Asigurare de viata inclusa`
                : t`Fara asigurare de viata`;

            return (
              <label
                className={`cursor-pointer rounded p-4 mx-auto w-1/${items.length} ${checked ? 'shadow-lg' : ''}`}
                style={{background: checked ? '#EAF1FB' : null}}
                key={index}>
                {isCetelemRefinance ? (
                  <OfferGroupItemCetelem item={item} />
                ) : (
                  <React.Fragment>
                    <RadioButton
                      checked={checked}
                      name={`offers-group-${groupId}`}
                      label={<Text ui="neptune">{label}</Text>}
                      id={id}
                      value={id}
                      onChange={() => {
                        setSelectedOfferId(id);
                      }}
                    />

                    <OfferGroupItem {...{item, isCreditCard}} />
                  </React.Fragment>
                )}
              </label>
            );
          })}
        </div>

        <Button
          boxShadow={false}
          color="purple"
          border={false}
          customProps={{type: 'button'}}
          buttonStyles="py-4 px-8"
          title={t`Aleg oferta`}
          onClick={() =>
            handleSelectOffer(selectedOfferId, isConsumerFinanceWithCard)
          }
          fullWidth
        />
      </div>
    </div>
  );
}
